import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import ConfirmDelete from '@/components/ConfirmDelete.vue';
import MyDialog from '@/components/MyDialog.vue';
let CharacterSheetProficienciesLanguages = class CharacterSheetProficienciesLanguages extends Vue {
    constructor() {
        super(...arguments);
        this.isOpen = false;
        this.newLanguage = '';
    }
    handleAdd() {
        this.$emit('updateCharacter', {
            customLanguages: {
                [this.customLanguages.length]: this.newLanguage
            }
        });
        this.isOpen = false;
    }
    handleDelete(index) {
        this.$emit('deleteCharacterProperty', { path: 'customLanguages', index });
    }
};
__decorate([
    Prop(Array)
], CharacterSheetProficienciesLanguages.prototype, "languages", void 0);
__decorate([
    Prop(Array)
], CharacterSheetProficienciesLanguages.prototype, "customLanguages", void 0);
CharacterSheetProficienciesLanguages = __decorate([
    Component({
        components: {
            ConfirmDelete,
            MyDialog
        }
    })
], CharacterSheetProficienciesLanguages);
export default CharacterSheetProficienciesLanguages;
